/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={exclude:0,include:1};export{e as WasmProvenanceBehaviorValues};
